import { Component, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NbMenuItem, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { delay, takeWhile } from 'rxjs/operators';
import { StateService } from '../../../@core/data/state.service';
import { AuthGuard } from '../../../@core/guards/auth.guard';
import { ChatService } from '../../../shared/services/chat/chat.service';
import { EventService } from './../../../shared/services/event/event.service';
import { SupportService } from './../../../shared/services/support/support.service';
import { environment } from '../../../../environments/environment';

// TODO: move layouts into the framework
@Component({
  selector: 'ngx-sample-layout',
  styleUrls: ['./sample.layout.scss'],
  template: `
    <nb-layout [center]="layout.id === 'center-column'">
      <nb-layout-header fixed  *ngIf="authGuard.canShow() && !modeMaintenance && !redirectingLeadinLive">
        <ngx-header [position]="sidebar.id === 'start' ? 'normal': 'inverse'"></ngx-header>
      </nb-layout-header>

      <nb-sidebar id='sidebarId' *ngIf="authGuard.canShow() && !modeMaintenance && !redirectingLeadinLive"
                  class="menu-sidebar"
                  tag="menu-sidebar"
                  state="compacted"
                  responsive="true"
                  [compactedBreakpoints]="sidebarCompactedBreakpoints"
                  [end]="sidebar.id === 'end'"
                  (click)="onSidebarClick($event)"
                  (keyup.esc)="onSidebarKey($event)">

        <nb-sidebar-footer>
          <a href="#" class="main-btn" (click)="returnToModulesPage()" title="{{ 'shared.modules' | Trans }}">
            <i class="fas fa-grip-horizontal"></i> <span>{{ 'shared.modules' | Trans }}</span>
          </a>
        </nb-sidebar-footer>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <nb-layout-column class="">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-column start class="small" *ngIf="layout.id === 'two-column' || layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <nb-layout-column class="small" *ngIf="layout.id === 'three-column'">
        <nb-menu [items]="subMenu"></nb-menu>
      </nb-layout-column>

      <nb-layout-footer fixed  [ngClass]="{'footer-responsive-with-button':paddingFooter }">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `
})
export class SampleLayoutComponent implements OnDestroy {

  subMenu: NbMenuItem[] = [
    {
      title: 'PAGE LEVEL MENU',
      group: true
    },
    {
      title: 'Buttons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/buttons'
    },
    {
      title: 'Grid',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/grid'
    },
    {
      title: 'Icons',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/icons'
    },
    {
      title: 'Modals',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/modals'
    },
    {
      title: 'Typography',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/typography'
    },
    {
      title: 'Animated Searches',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/search-fields'
    },
    {
      title: 'Tabs',
      icon: 'ion ion-android-radio-button-off',
      link: '/pages/ui-features/tabs'
    }
  ];
  layout: any = {};
  sidebar: any = {};
  /** Todos los breakpoints: evita que Nebular abra el menú al redimensionar en desktop (lg→xl). */
  sidebarCompactedBreakpoints = ['xs', 'is', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'];
  currentTheme: string;
  paddingFooter: boolean;
  private alive = true;
  modeMaintenance: any;
  redirectingLeadinLive: any;

  constructor(protected stateService: StateService,
    protected menuService: NbMenuService,
    protected themeService: NbThemeService,
    protected sidebarService: NbSidebarService,
    public authGuard: AuthGuard,
    public chatService: ChatService,
    private readonly router: Router,
    private readonly eventService: EventService,
    private readonly supportService: SupportService
  ) {
    this.router.events.subscribe(event => {
      switch (this.router.url.split('/')[1]) {
        case 'leads':
          this.paddingFooter = true;
          break;
        case 'mylead':
          this.paddingFooter = true;
          break;
        default:
          this.paddingFooter = false;
          break;
      }
    });
    this.stateService.onLayoutState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((layout: string) => this.layout = layout);

    this.stateService.onSidebarState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((sidebar: string) => {
        this.sidebar = sidebar;
      });

    /*this.menuService.onItemClick().subscribe(event => {
      if (event.item['key'] === 'chat_toggle') {
        this.supportService.toggle();
      }
    });*/

    this.eventService.subscribe('modeMaintenance', (status) => {
      this.modeMaintenance = status;
    });

    this.eventService.subscribe('redirectingLeadinLive', (status) => {
      this.redirectingLeadinLive = status;
    });

    this.menuService.onItemClick()
      .pipe(
        takeWhile(() => this.alive),
        delay(20)
      )
      .subscribe(() => {
        this.sidebarService.collapse('menu-sidebar');
        this.unlockBodyScroll();
      });

    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
        this.currentTheme = theme.name;
      });
  }

  ngOnDestroy(): void {
    this.alive = false;
    this.unlockBodyScroll();
  }

  private returnToModulesPage() {
    window.location.href = environment.urlStock;
  }

  private unlockBodyScroll(): void {
    setTimeout(() => {
      const sidebar = document.getElementById('sidebarId');
      if (!sidebar || !sidebar.classList.contains('expanded')) {
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
    });
  }

  //to close the menu when the background is clicked
  onSidebarClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    
    if (target.classList.contains('main-container')) {
        this.sidebarService.toggle(true, 'menu-sidebar');
        this.unlockBodyScroll();
    }
  }

  //to close the menu when esc key is pressed
  @HostListener('document:keyup.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    const sidebar = document.querySelector('[tag="menu-sidebar"]');
    if (sidebar && sidebar.classList.contains('expanded')) {
      this.sidebarService.toggle(true, 'menu-sidebar');
      this.unlockBodyScroll();
      event.preventDefault();
    }
  }

}
